import { render, staticRenderFns } from "./salesShippingNotice.vue?vue&type=template&id=28008510&scoped=true"
import script from "./salesShippingNotice.vue?vue&type=script&lang=js"
export * from "./salesShippingNotice.vue?vue&type=script&lang=js"
import style0 from "./salesShippingNotice.vue?vue&type=style&index=0&id=28008510&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28008510",
  null
  
)

export default component.exports